module.exports = "App\\Entity\\Actor:\n    actor{1..10}:\n      name: '<name()>'\n      picture: '<image(\"./public/images\", 500, 500, \"people\", 0)>'"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/fixtures-actor.txt
// module id = 647
// module chunks = 111487850492888